import * as Types from '../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Wed Dec 03 2025 13:15:48 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type SpellboundInfoQueryQueryVariables = Types.Exact<{
  bundleName: Types.Scalars['String']['input'];
}>;


export type SpellboundInfoQueryQuery = { __typename?: 'Query', appMetadata: { __typename?: 'AppMetadata', spellboundDeployment?: { __typename?: 'BundleDeployment', name: string, source: string, gitSha: string, deployedAt: string } | null | undefined } };


export const SpellboundInfoQueryDocument = gql`
    query spellboundInfoQuery($bundleName: String!) {
  appMetadata {
    spellboundDeployment(bundleName: $bundleName) {
      name
      source
      gitSha
      deployedAt
    }
  }
}
    `;

/**
 * __useSpellboundInfoQueryQuery__
 *
 * To run a query within a React component, call `useSpellboundInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpellboundInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpellboundInfoQueryQuery({
 *   variables: {
 *      bundleName: // value for 'bundleName'
 *   },
 * });
 */
export function useSpellboundInfoQueryQuery(baseOptions: Apollo.QueryHookOptions<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables> & ({ variables: SpellboundInfoQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>(SpellboundInfoQueryDocument, options);
      }
export function useSpellboundInfoQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>(SpellboundInfoQueryDocument, options);
        }
export function useSpellboundInfoQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>(SpellboundInfoQueryDocument, options);
        }
export type SpellboundInfoQueryQueryHookResult = ReturnType<typeof useSpellboundInfoQueryQuery>;
export type SpellboundInfoQueryLazyQueryHookResult = ReturnType<typeof useSpellboundInfoQueryLazyQuery>;
export type SpellboundInfoQuerySuspenseQueryHookResult = ReturnType<typeof useSpellboundInfoQuerySuspenseQuery>;
export type SpellboundInfoQueryQueryResult = Apollo.QueryResult<SpellboundInfoQueryQuery, SpellboundInfoQueryQueryVariables>;